import { CategoriesListResponse } from 'modules/products'
import { apiService, createRequestHeadersConfig } from 'shared/api'

import { filterOnlyVisibleCategories } from './utils'

const api = apiService()

type GetCategoriesListPayload = {
  token?: string
}

export const getCategoriesList = (
  payload: GetCategoriesListPayload
): Promise<CategoriesListResponse> => {
  return api.get(`/product-categories`, createRequestHeadersConfig(payload?.token))
}

export const fetchCategoriesQuery = async (token: string | undefined) => {
  const response = await getCategoriesList({ token })

  if (response.data?.data) {
    return filterOnlyVisibleCategories(response.data?.data)
  }

  return []
}
